export const BENEF_ITEM_PER_PAGE = 50;
export const BENEF_NAME_REGEX = /^[a-zA-Z0-9\/\-\?\:\(\)\.\'\+ ]+$/;
